import { Button } from "@/design-system/components/Button/Button";
import { toast } from "@/design-system/components/Toast/Toast";

import type { ReadyEntry } from "./activityState";

// One shared id, so a newer response replaces the toast on screen instead of
// stacking under it.
export const RESPONSE_READY_TOAST_ID = "ai-chat-response-ready";

export function showResponseReadyToast(
  entry: ReadyEntry,
  onView: (id: string) => void,
) {
  toast.success(
    <span className="flex items-center gap-3">
      <span className="min-w-0">
        <span className="block text-sm">Response ready</span>
        <span className="block max-w-[220px] truncate text-xs text-white/70">
          {entry.title}
        </span>
      </span>
      <Button
        size="sm"
        onClick={() => {
          toast.dismiss(RESPONSE_READY_TOAST_ID);
          onView(entry.id);
        }}
      >
        View
      </Button>
    </span>,
    { id: RESPONSE_READY_TOAST_ID, duration: 6000 },
  );
}
